/* eslint-disable */
// src/layouts/machineType/index.js

import React, { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import machineTypeTableData from "layouts/machineType/data/machineTypeTableData";
import machineTypeService from "services/machineTypeService";

function MachineType() {
  const [machineTypes, setMachineTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMachineTypes = async () => {
      try {
        const machineTypesData = await machineTypeService.getMachineTypes();
        setMachineTypes(machineTypesData);
      } catch (error) {
        console.error("Error fetching machine types:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMachineTypes();
  }, []);

  const { columns, rows } = machineTypeTableData({ machineTypes });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Tipos de máquina configurados
                </MDTypography>
              </MDBox>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isLoading={isLoading}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MachineType;
